<template>
  <div class="index-promotion-content">
    <div class="index-promotion-content-box" v-for="(item,index) in promotionList" :key="index">
      <div class="index-promotion-content-header">
        <div class="index-promotion-content-title-box">
          <div class="index-promotion-content-title-box-row">
            <a-icon class="icon-tag" type="environment"/>
            <span class="index-promotion-content-title-text">{{ $dt(item, 'CITY_NAME') }}</span>
            <a-icon class="icon-more" type="more"/>
          </div>
          <div class="index-promotion-content-title-box-row">
            <a-icon class="icon-tag" type="environment"/>
            <span class="index-promotion-content-title-text">{{ $dt(item, 'D_CITY_NAME') }}</span>
          </div>
        </div>
        <div :class="boxSizeClass(item)">
          <div class="index-promotion-content-info-box-size">{{ $dt(item, 'BOX_SIZE_NAME') }}</div>
          <div class="index-promotion-content-info-box-state">{{ $dt(item, 'BOX_STATE_NAME') }}</div>
        </div>
      </div>
      <div class="index-promotion-content-info-qty-box">
        <div class="index-promotion-content-info-qty-text">{{ $t('通用_箱量') }}：{{Number(item.ROUTE_QTY) }}</div>

        <div class="index-promotion-content-box-info-price">
          <div>
            <span>{{ item.VALID_PRICE > 0 ? '' : $t('subsidy') + ' ' }}$</span>
            <span class="index-promotion-content-box-info-price-text">
                    {{ Math.abs(item.VALID_PRICE) }}
            </span>
          </div>
          <div>
            <a-button class="index-promotion-use-box-btn" :disabled="Number(item.ROUTE_QTY) === 0"
                      @click="applyBox(item,20391002)" type="primary">
              {{ $t('apply') }}
            </a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index-promotion-list',
  props: {
    promotionList: { type: Array, default: () => [] }
  },
  data () {
    return {
    };
  },
  computed: {
    boxSizeClass() {
      return (item) => {
        switch (item.BOX_SIZE_NAME) {
          case '20GP':
            return 'index-promotion-content-info-box-20GP';
          case '40HQ':
            return 'index-promotion-content-info-box-40HQ';
          default:
            return 'index-promotion-content-info-box-default';
        }
      };
    }
  },
  methods: {
    applyBox(item, type){
      this.$emit('applyBox', item, type);
    }
  }
}
</script>

<style lang="scss">
.index-promotion-content {
  display: flex;
  flex-wrap: wrap;
  .index-promotion-content-box {
    width: 287px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px solid #D9E3EF;
    margin: 6px;
    display: flex;
    flex-direction: column;

    .index-promotion-content-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 20px;
      background: linear-gradient(270deg, #F7FAFC 0%, #E7EFF7 100%);
      border-radius: 6px 6px 0 0;
      .index-promotion-content-title-box{
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        > .index-promotion-content-title-box-row{
          position: relative;
          .icon-more{
            font-size: 10px;
            position: absolute;
            left: 2.33px;
            bottom: -7px;
            color: #BBBBBB;
          }
          +.index-promotion-content-title-box-row{
            margin-top: 4px;
          }
        }
        .index-promotion-content-title-text{
          margin-left: 6px;
          height: 18px;
        }
        .icon-tag{
          color: #A1C9F2;
          font-size: 14px;
        }
      }
      .index-promotion-content-info-box-default{
        font-size: 14px;
        .index-promotion-content-info-box-size{
          padding: 0 6px;
          border: 1px solid #E3E3E3;
          border-radius: 4px 4px 0 0;
          background: #E3E3E3;
          color: #666666;
        }
        .index-promotion-content-info-box-state{
          padding: 0 6px;
          border-left: 1px solid #E3E3E3;
          border-bottom: 1px solid #E3E3E3;
          border-right: 1px solid #E3E3E3;
          background: #FFFFFF;
          color: #666666;
          text-align: center;
          border-radius: 0 0 4px 4px;
        }
      }
      .index-promotion-content-info-box-20GP{
        font-size: 14px;
        .index-promotion-content-info-box-size{
          padding: 0 6px;
          border: 1px solid #56C38A;
          border-radius: 4px 4px 0 0;
          background: #56C38A;
          color: #FFFFFF;
        }
        .index-promotion-content-info-box-state{
          padding: 0 6px;
          border-left: 1px solid #56C38A;
          border-bottom: 1px solid #56C38A;
          border-right: 1px solid #56C38A;
          background: #FFFFFF;
          text-align: center;
          border-radius: 0 0 4px 4px;
        }
      }
      .index-promotion-content-info-box-40HQ{
        font-size: 14px;
        .index-promotion-content-info-box-size{
          padding: 0 6px;
          border: 1px solid #FD9C00;
          border-radius: 4px 4px 0 0;
          background: #FD9C00;
          color: #FFFFFF;
        }
        .index-promotion-content-info-box-state{
          padding: 0 6px;
          border-left: 1px solid #FD9C00;
          border-bottom: 1px solid #FD9C00;
          border-right: 1px solid #FD9C00;
          background: #FFFFFF;
          text-align: center;
          border-radius: 0 0 4px 4px;
        }
      }
    }

    .index-promotion-content-info-qty-box {
      padding: 12px 20px 16px 20px;
      display: flex;
      flex: 1;
      flex-direction: column;
      .index-promotion-content-info-qty-text {
        word-wrap: break-word;
        word-break: break-all;
      }

      .index-promotion-content-box-info-price {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 600;
        color: #FF6F27;
        margin-top: 8px;
        span {
          font-size: 16px;
        }
        .index-promotion-content-box-info-price-text {
          font-size: 24px;
          margin-left: 2px;
        }

        .index-promotion-use-box-btn {
          transition: all 0.5s;
          background: linear-gradient(137deg, #51A4FA 0%, #1F7EE0 100%);
          font-weight: 600;
          border: none;
        }

        .index-content-promotion-use-box-btn:hover {
          transform: scale(1.1);
        }
      }
    }
  }
  .index-promotion-content-box:hover {
    box-shadow: 0px 2px 11px 0px rgba(0, 0, 0, 0.1);
  }
}
</style>